import { ModalForm } from '@ant-design/pro-components'
import { Form, Input, type FormInstance } from 'antd'

export type ApplicationRejectionForm = {
  rejectionReason: string
}

export function ApplicationRejectionModal({
  applicantName,
  form,
  open,
  pending,
  onClose,
  onFinish
}: {
  applicantName?: string
  form: FormInstance<ApplicationRejectionForm>
  open: boolean
  pending: boolean
  onClose: () => void
  onFinish: (values: ApplicationRejectionForm) => Promise<boolean>
}) {
  return (
    <ModalForm<ApplicationRejectionForm>
      form={form}
      initialValues={{ rejectionReason: '' }}
      layout="vertical"
      modalProps={{ destroyOnHidden: true, mask: { closable: false }, onCancel: onClose }}
      onFinish={onFinish}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) {
          onClose()
        }
      }}
      open={open}
      scrollToFirstError={{ focus: true }}
      submitter={{
        resetButtonProps: { disabled: pending, onClick: onClose },
        searchConfig: { resetText: '取消', submitText: '确认拒绝' },
        submitButtonProps: { danger: true, loading: pending }
      }}
      title={`拒绝账号申请 · ${applicantName ?? ''}`}
      width={480}
    >
      <Form.Item
        extra="拒绝后，申请人可以查看原因、修改资料并重新提交。"
        label="拒绝原因"
        name="rejectionReason"
        rules={[
          { message: '请填写拒绝原因', required: true, whitespace: true },
          { message: '拒绝原因至少需要 2 个字符', min: 2 },
          { message: '拒绝原因不能超过 500 个字符', max: 500 }
        ]}
      >
        <Input.TextArea autoFocus maxLength={500} placeholder="请说明拒绝原因…" rows={4} showCount />
      </Form.Item>
    </ModalForm>
  )
}
